module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9546.5e55925b.jpg";